import { useState } from "react";
import _debounce from "lodash/debounce";
import { IPagination } from "../interfaces/shared/IPagination";

interface IProps {
  perPage?: number;
  paginationKeys?: any;
}
export const usePagination = ({ perPage = 10, paginationKeys }: IProps) => {
  const [pagination, setPagination] = useState<IPagination | any>({
    page: 1,
    perPage: perPage,
    ...paginationKeys,
  });
  const [inputValue, setInputValue] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [count, setCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const handlePages = (updatePage: number) => {
    setPagination({ ...pagination, page: updatePage });
    setPage(updatePage);
  };

  const handleUpdateList = () => {
    setPagination((prev: IPagination) => ({
      ...prev,
      updatedAt: new Date()?.getTime(),
      page: 1,
    }));
  };

  const changeFilterHandler = _debounce(
    (name: string, value: string | null | number | boolean) => {
      setPagination((prev: IPagination) => ({
        ...prev,
        page: 1,
        [name]: value,
      }));
    },
    300,
  );

  return {
    pagination,
    page,
    setPage,
    totalPages,
    setTotalPages,
    setPagination,
    handlePages,
    changeFilterHandler,
    count,
    setCount,
    totalCount,
    setTotalCount,
    handleUpdateList,
    inputValue,
    setInputValue,
    perPage: pagination.perPage,
  };
};
